import type { ServiceFormData } from '@takeshape/service-providers';
import { createRoutine } from 'app/common/utils/new-routines';
import { type ActionType, createAction } from 'typesafe-actions';
import type { BootstrapParams } from './components/service-bootstrap/service-bootstrap-dialog';
import type { ServiceHealth } from './types';

export const toggleBootstrapDialog = createAction('services/TOGGLE_BOOTSTRAP_DIALOG')<boolean>();
export const setBootstrapDialogProvider = createAction('services/SET_BOOTSTRAP_DIALOG_PROVIDER')<string>();
export const bootstrapConfirm = createAction('services/BOOTSTRAP_DIALOG_CONFIRM')<BootstrapParams>();
export const bootstrapCancel = createAction('services/BOOTSTRAP_DIALOG_CANCEL')();
export const startBootstrap = createAction('services/START_BOOTSTRAP')<string>();
export const reindexService = createAction('services/REINDEX_SERVICE')<string>();
export const setServiceHealthCheck = createAction('services/SET_SERVICE_HEALTH_CHECK')<ServiceHealth>();
export const clearServiceHealthChecks = createAction('services/CLEAR_SERVICE_HEALTH_CHECKS')<void>();
export const setShouldClearServiceHealthChecks = createAction(
  'services/SET_SHOULD_CLEAR_SERVICE_HEALTH_CHECKS'
)<void>();
export const showInvalidConfiguration = createAction('services/SHOW_INVALID_CONFIGURATION')<ServiceHealth>();
export const hideInvalidConfiguration = createAction('services/HIDE_INVALID_CONFIGURATION')<boolean>();

export type RunBootstrapRoutineMeta = {
  serviceId: string;
};

export type RunBootstrapRoutineRequested = {
  params: BootstrapParams;
};

export type RunBootstrapRoutineFulfilled = Array<{
  result: {
    totalCreated: number;
  };
}>;

export type AddServicePayload = {
  providerName: string;
};

export const runBootstrapRoutine = createRoutine('services/RUN_BOOTSTRAP')<
  RunBootstrapRoutineMeta,
  RunBootstrapRoutineRequested,
  undefined,
  RunBootstrapRoutineFulfilled,
  string,
  undefined
>();

export const addServiceRoutine = createRoutine('services/ADD_SERVICE')<
  undefined,
  AddServicePayload,
  undefined,
  string,
  string,
  undefined
>();

export type SaveServiceRoutinePayload = {
  data: ServiceFormData;
  dirty: string[];
};

export const saveServiceRoutine = createRoutine('services/SAVE_SERVICE')<
  undefined,
  SaveServiceRoutinePayload,
  undefined,
  undefined,
  string,
  undefined
>();

export const importShopifyProductRoutine = createRoutine('services/IMPORT_SHOPIFY_PRODUCT')<
  undefined,
  undefined,
  undefined,
  undefined,
  string,
  undefined
>();

export type AuthFlowPayload = {
  providerName: string;
  serviceId?: string;
};

export const authFlow = createRoutine('serviceOAuth/OAUTH_FLOW')<
  undefined,
  AuthFlowPayload,
  undefined,
  AuthFlowPayload,
  string,
  undefined
>();

export type ServiceActionType =
  | ActionType<typeof authFlow>
  | ActionType<typeof importShopifyProductRoutine>
  | ActionType<typeof saveServiceRoutine>
  | ActionType<typeof toggleBootstrapDialog>
  | ActionType<typeof setBootstrapDialogProvider>
  | ActionType<typeof runBootstrapRoutine>
  | ActionType<typeof startBootstrap>
  | ActionType<typeof reindexService>
  | ActionType<typeof setServiceHealthCheck>
  | ActionType<typeof setShouldClearServiceHealthChecks>
  | ActionType<typeof clearServiceHealthChecks>
  | ActionType<typeof showInvalidConfiguration>
  | ActionType<typeof hideInvalidConfiguration>;
